import { baseStyles, createInputStyle } from '../styles';
import AuthActionButton from './AuthActionButton';
import PhoneInputWithCountrySelect from 'react-phone-number-input';
import { useAuthStep } from '../context/AuthStepContext';
import { signIn } from '../AuthState';

const PhoneInputForm = () => {
  const {
    phoneNumber,
    email,
    setPhoneNumber,
    nextStep,
    setIsLoading,
    resetStep,
  } = useAuthStep();

  const handleNext = async () => {
    try {
      setIsLoading(true);
      await signIn(email, phoneNumber, null);
      nextStep();
    } catch (error) {
      console.error(error);
      resetStep();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form style={baseStyles.clientReg}>
      <h6>Please enter your phone number</h6>
      <PhoneInputWithCountrySelect
        style={createInputStyle('default')}
        numberInputProps={{
          className: 'border-0',
        }}
        defaultCountry="AU"
        placeholder="Enter phone number"
        onChange={(phoneNumber) =>
          setPhoneNumber(phoneNumber?.toString() ?? '')
        }
        value={phoneNumber}
      />
      <div className="my-3" />
      <AuthActionButton onClick={handleNext} />
    </form>
  );
};

export default PhoneInputForm;
